import type {Ability} from '../../../../generated/types';
import {ABILITIES} from './abilities';

export const STANDARD_ARRAY = [15, 14, 13, 12, 10, 8];

export const POINT_BUY_BUDGET = 27;
export const POINT_BUY_MIN = 8;
export const POINT_BUY_MAX = 15;
/** цена значения по таблице «Цена значений характеристик»: 14 стоит 7, 15 стоит 9 */
export const POINT_BUY_COSTS: Record<number, number> = {8: 0, 9: 1, 10: 2, 11: 3, 12: 4, 13: 5, 14: 7, 15: 9};

export const RANDOM_ROLL_FORMULA = '4d6kh3';

/** пределы значения характеристики по правилам */
export const MANUAL_MIN = 1;
export const MANUAL_MAX = 30;

export type AbilityMethod = 'standard' | 'pointBuy' | 'random' | 'manual';

/** один бросок 4d6: все кости и сумма трёх наибольших */
export type AbilityRoll = {dice: number[]; total: number};

export type RandomRollGroup = {
	/** шесть бросков группы; null — ещё не брошено */
	rolls: (AbilityRoll | null)[];
	/** характеристика → номер броска в группе */
	assigned: Partial<Record<Ability, number>>;
};

/** как набирали характеристики: выбранный способ и незаконченные назначения */
export type AbilityGeneration =
	| {method: 'standard'; assigned: Partial<Record<Ability, number>>}
	| {method: 'pointBuy'}
	| {method: 'random'; groups: RandomRollGroup[]; savedGroup?: number}
	| {method: 'manual'};

export const ROLLS_PER_GROUP = ABILITIES.length;

export const emptyRollGroup = (): RandomRollGroup => ({rolls: Array(ROLLS_PER_GROUP).fill(null), assigned: {}});

export const initialGeneration = (method: AbilityMethod): AbilityGeneration => {
	switch (method) {
		case 'standard':
			return {method, assigned: {}};
		case 'random':
			return {method, groups: [emptyRollGroup()]};
		default:
			return {method};
	}
};

export const pointBuySpent = (scores: Record<Ability, number>) =>
	ABILITIES.reduce((total, ability) => total + (POINT_BUY_COSTS[scores[ability]] ?? 0), 0);

/** значения приобретения за очки, на которые хватает оставшихся очков с учётом текущего значения */
export function affordablePointBuyValues(scores: Record<Ability, number>, ability: Ability): number[] {
	const left = POINT_BUY_BUDGET - pointBuySpent(scores) + (POINT_BUY_COSTS[scores[ability]] ?? 0);
	return Object.keys(POINT_BUY_COSTS)
		.map(Number)
		.filter((value) => POINT_BUY_COSTS[value] <= left);
}

export const pointBuyStart = (): Record<Ability, number> =>
	Object.fromEntries(ABILITIES.map((ability) => [ability, POINT_BUY_MIN])) as Record<Ability, number>;

/** сколько характеристик ещё без значения: для отметки шага мастера */
export function unassignedAbilities(generation: AbilityGeneration | undefined): number {
	if (!generation) return ABILITIES.length;
	if (generation.method === 'standard') {
		return ABILITIES.filter((ability) => generation.assigned[ability] === undefined).length;
	}
	if (generation.method === 'random') return generation.savedGroup === undefined ? ABILITIES.length : 0;
	return 0;
}
